import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { getFigurineImageSrc } from '../utils/figurineMedia';

export default function CartPage() {
  const { cartItems, removeFromCart, clearCart, total, incrementQuantity, decrementQuantity } = useCart();

  return (
    <div className="nfig-page">
      <main className="nfig-container max-w-5xl">
        <div className="mb-9">
          <p className="nfig-kicker mb-3">Selected figures</p>
          <h1 className="nfig-page-title">Your Cart</h1>
        </div>

        {cartItems.length === 0 ? (
          <section className="nfig-panel rounded-2xl p-10 text-center sm:p-16">
            <p className="text-2xl font-black uppercase text-white">Your cart is empty</p>
            <p className="mx-auto mt-3 max-w-md text-slate-400">Your next centerpiece is waiting somewhere in the NFig collection.</p>
            <Link to="/browse" className="nfig-button-primary mt-7">Explore Figures</Link>
          </section>
        ) : (
          <div className="grid gap-7 lg:grid-cols-[1fr_320px] lg:items-start">
            <div className="space-y-4">
              {cartItems.map((item, index) => (
                <article key={`${item.id || item.name}-${index}`} className="nfig-panel flex flex-col gap-4 rounded-xl p-4 sm:flex-row sm:items-center">
                  <div className="flex h-28 w-full shrink-0 items-center justify-center rounded-lg bg-gradient-to-b from-slate-100 to-blue-50 p-2 sm:w-28">
                    <img src={getFigurineImageSrc(item)} alt={item.name} className="h-full w-full object-contain" />
                  </div>
                  <div className="min-w-0 flex-1">
                    {item.stock === 0 && <p className="mb-1 text-xs font-black uppercase tracking-widest text-red-300">Pre-order</p>}
                    <p className="text-xs font-bold uppercase tracking-widest text-blue-300">{item.series}</p>
                    <h2 className="mt-1 text-xl font-bold">{item.name}</h2>
                    <div className="mt-2 flex gap-4 text-sm">
                      <span className="font-black text-[#f5c451]">★ {item.rating}</span>
                      <span className="font-black text-white">₪{item.value}</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between gap-4 sm:flex-col sm:items-end">
                    <div className="flex items-center gap-3 rounded-lg border border-white/10 bg-black/20 p-1">
                      <button onClick={() => decrementQuantity(index)} className="flex h-9 w-9 items-center justify-center rounded bg-white/5 hover:bg-blue-500/20">−</button>
                      <span className="min-w-5 text-center font-black">{item.quantity}</span>
                      <button onClick={() => incrementQuantity(index)} className="flex h-9 w-9 items-center justify-center rounded bg-white/5 hover:bg-blue-500/20">+</button>
                    </div>
                    <button onClick={() => removeFromCart(index)} className="text-xs font-bold uppercase tracking-wider text-slate-500 transition hover:text-red-300">Remove</button>
                  </div>
                </article>
              ))}
            </div>

            <aside className="nfig-panel rounded-xl p-6 lg:sticky lg:top-28">
              <p className="nfig-kicker">Order summary</p>
              <div className="mt-5 flex items-center justify-between border-y border-white/10 py-5">
                <span className="text-sm uppercase tracking-widest text-slate-400">Total</span>
                <span className="text-3xl font-black">₪{total}</span>
              </div>
              <button className="nfig-button-primary mt-5 w-full">Proceed to Payment</button>
              <button onClick={clearCart} className="nfig-button-danger mt-3 w-full">Clear Cart</button>
            </aside>
          </div>
        )}
      </main>
    </div>
  );
}
